import { Component, OnInit } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { EntertainmentService } from '../entertainment.service';
import { environment } from '../../../../../../src/environments/environment';
import { SelectionInfo } from 'src/app/post-login/selectors/multi-selection/multi-selection.model';
import { HaloToastService, EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { IHaloDropDown } from 'src/app/core/halo-dropdown/halo-dropdown.interface';
import { ZENDESK_ARTICLES } from 'src/app/core/data/constants';
@Component({
  selector: 'app-entertainment-internet',
  templateUrl: './entertainment-internet.component.html',
  styleUrls: ['./entertainment-internet.component.scss']
})
export class EntertainmentInternetComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  activatedComponentRef: any;
  active: number;
  haloWebCloudURL: string = environment.haloWebCloudBasePath;
  selectionInfo: SelectionInfo;
  hasEditPermission = false;
  isInternetAvailable = false;
  internetEntertainmentData: any;
  defaultIPTVTempData = {
    isEnabledEdited: "false",
    name: "",
    rowNumber: "",
    url: "",
    onUpdateClicked: false
  };
  iptvTempData: any;
  onAddClicked = false;
  internetList: any;
  originalInternetList: any;
  isInternelAvailable = false;
  showDisableTvEntertainmentPopup: any;
  isTvDisablePublished: any;
  hasADraft: any;
  selectedRowNumberToClear: any;
  sub = new Subscription();
  publishedPopupProperties = {
    title: this._commonUtil.replaceValueAsHTMLOnTranslatedText('DISABLE.TV.IPTV.SETTINGS', ["IPTV"]),
    message: this._commonUtil.replaceValueAsHTMLOnTranslatedText('DISABLE.TV.IPTV.SETTINGS.MSG', ["IPTV", "IPTV", "IPTV"]),
    isWarningPopup: false,
    ctaButtonLabel: 'PUBLISH',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };

  showPublishModal: boolean = false;
  customLoaderIsLoading = false;//customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg: string;
  customLoaderRedirectButtonLabel: string;
  customLoaderRedirectButtonUrl: string;

  inetStatusList = [{ value: 'F', text: this._commonUtil.translateText("FULL.BROWSING") }, { value: 'M', text: this._commonUtil.translateText("MANAGER.LINKS.ONLY") }, { value: 'N', text: this._commonUtil.translateText("NONE") }];
  selectedForm: string | number | null = null;
  zendeskArticles = ZENDESK_ARTICLES;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private _commonUtil: CommonUtil,
    private _entertainmentService: EntertainmentService,
    private _toast: HaloToastService,
  ) {
    this.iptvTempData = JSON.parse(JSON.stringify(this.defaultIPTVTempData));
  }

  ngOnInit(): void {
  }

  onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      if (selectionInfo) {
        this.selectionInfo = selectionInfo;
        this.hasEditPermission = this.selectionInfo.facility.summary?.isLoggedInManagerAdmin === 'true' || this.selectionInfo.facility.summary?.userRights.customize === 'F';
        let consoleRights = this._commonUtil.rootScopeData?.consoleRights?.get(this.selectionInfo.consoleType);
        if(consoleRights.hasInternetSetting === 'true'){
          this.getInternetEntertainmentData();
        }
      }
    });
  }

  async getInternetEntertainmentData() {
    this.customLoaderIsLoading = true;
    var payload = { "facilityIds": this.selectionInfo.facility.facilityId.split(',')[0], "consoleType": this.selectionInfo.consoleType };
    try {
      let resp: any = await this._entertainmentService.getInternetEntertainmentData(payload);
      this.customLoaderIsLoading = false;
      if (resp && resp.internetSettingsDetails[0]) {
        for (var j = 0; j < 12; j++) {
          if (resp.internetSettingsDetails[0].internetSettingsVOList[j]) {
            resp.internetSettingsDetails[0].internetSettingsVOList[j] = {
              "rowNumber": j.toString(),
              "bookmarkDisplayName": resp.internetSettingsDetails[0].internetSettingsVOList[j].bookmarkDisplayName,
              "bookmarkUrl": resp.internetSettingsDetails[0].internetSettingsVOList[j].bookmarkUrl,
              "isValidUrl": true,
              "isEnabledEdited": "false",
              "showAddWebsiteShortcut": false,
              "onUpdateClicked": false
            }
          } else {
            resp.internetSettingsDetails[0].internetSettingsVOList.push(
              {
                "rowNumber": j.toString(),
                "bookmarkDisplayName": "",
                "bookmarkUrl": "",
                "isValidUrl": true,
                "isEnabledEdited": "false",
                "showAddWebsiteShortcut": true,
                "onUpdateClicked": false
              }
            )
          }
        }
        this.internetEntertainmentData = resp.internetSettingsDetails[0];
        this.selectedForm = this.internetEntertainmentData.inetStatus;
        this.originalInternetList = this.internetEntertainmentData.internetSettingsVOList ? this.internetEntertainmentData.internetSettingsVOList : [];
        this.internetList = JSON.parse(JSON.stringify(this.originalInternetList));
        this.isInternetAvailable = this.internetList ? true : false;
      }
    } catch (error) {
      this.customLoaderErrorMsg = HaloCustomLoaderErrorType.APIFAILED;
    }
  }
  internetAccessDropdownChanged(selected: IHaloDropDown | null) {
    this.selectedForm = selected ? selected.value : null;
    this.internetEntertainmentData.inetStatus = this.selectedForm;
  }
  prepareinternetEntertainmentData(internetEntertainmentData: any): any {
    let data = internetEntertainmentData;
    let data2 = data.iptvSettingsVOList.forEach((element: any) => {
      element.isEnabledEdited = "false";
    });
    return data2;
  }

  prepareInternetList(internetList: any) {
    let list: {}[] = [];
    internetList.forEach((element: any, index: number) => {
      list.push({
        name: element.name,
        url: element.url,
        rowNumber: (index + 1).toString()
      })
    });
    return list;
  }
  updateStatsInternetList() {
    this.internetList.filter((val: any) => val.isEnabledEdited === "true").map((ele: any) => {
      ele.isValidUrl = this.validateUrl(ele.bookmarkUrl.trim());
      if (ele.isValidUrl && ele.bookmarkDisplayName.trim() === "" ) {
        ele.bookmarkDisplayName = this.getBookmarkDisplayNameByBookmarkUrl(ele);
      }
      ele.onUpdateClicked = true;
    });
  }

  onSelectInternetAccess(internetEntertainmentData: any) {
    internetEntertainmentData.isInetUserIdReq = internetEntertainmentData.isInetUserIdReq === "true" ? "false" : "true";
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  onSelectGoogleSearch(internetEntertainmentData: any) {
    internetEntertainmentData.isGoogleSearchEnabled = internetEntertainmentData.isGoogleSearchEnabled === "true" ? "false" : "true";
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }
  async publishIPTVEntertainment() {
    this.updateStatsInternetList();
    let isInvalidUrlExist = this.internetList.filter((val: any) => val.isValidUrl === false).length>0?true:false;
    let preparedInternetList = this.internetList.filter((val: any) => val.isValidUrl === true && val.bookmarkDisplayName && val.bookmarkUrl)
    .map((ele:any) => { return {'bookmarkUrl':ele.bookmarkUrl,'bookmarkDisplayName':ele.bookmarkDisplayName}});

    if (!isInvalidUrlExist && preparedInternetList.length > 0) {
      this.customLoaderIsLoading = true;
      this.internetEntertainmentData.consoleType = this.selectionInfo.consoleType;
      let payload = {
        consoleType: this.internetEntertainmentData.consoleType,
        facilityId: this.internetEntertainmentData.facilityId,
        inetStatus:this.internetEntertainmentData.inetStatus,
        internetSettingsVOList: preparedInternetList,
        isGoogleSearchEnabled:this.internetEntertainmentData.isGoogleSearchEnabled,
        isInetUserIdReq:this.internetEntertainmentData.isInetUserIdReq
      }
      try {
        let resp: any = await this._entertainmentService.postInternetEntertainmentData(payload);
          this.customLoaderIsLoading = false;
          this.getInternetEntertainmentData();
          var publishOkay = this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENTERTAINMENT.TABS.PUBLISH.SUCCESS.MESSAGE', [this._commonUtil.translateText('INTERNET')]);
          this._toast.creatToast(this._commonUtil.replaceValueAsHTMLOnTranslatedText(publishOkay, []), EToastType.SUCCESS);
          this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
      } catch (error) {
        this.customLoaderErrorMsg = HaloCustomLoaderErrorType.APIFAILED;
      }
    }
  }

  onPublishConfirmation() {
    this.showPublishModal = false;
    this.internetEntertainmentData.tvEnabled = "false";
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    this.publishIPTVEntertainment();
  }

  closePublishedModal() {
    this.internetEntertainmentData.tvEnabled = "true";
    this.showPublishModal = false;
  }

  learnMore() {
    window.open(this.zendeskArticles.FACILITY_CONNECT_WEB_SHORTCUTS_PAGE_OVERVIEW, '_blank');
  }

  onInternetActionButtonClick(action: string, item: any, index: number) {
    if (action === 'CLEAR') {
      this.selectedRowNumberToClear = item.rowNumber;
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;

      this.originalInternetList.filter((val: any) => val.rowNumber === this.selectedRowNumberToClear).map(
        (ele: any) => {
          ele.bookmarkDisplayName = "",
            ele.bookmarkUrl = "",
            ele.isValidUrl = true,
            ele.isEnabledEdited = "false",
            ele.showAddWebsiteShortcut = true,
            ele.onUpdateClicked = false
        }
      );

      this.internetList.filter((val: any) => val.rowNumber === this.selectedRowNumberToClear).map(
        (ele: any) => {
          ele.bookmarkDisplayName = "",
            ele.bookmarkUrl = "",
            ele.isValidUrl = true,
            ele.isEnabledEdited = "false",
            ele.showAddWebsiteShortcut = true,
            ele.onUpdateClicked = false
        }
      );
    }
  }

  onInternetActionBarClick(action: string, item: any, index: number) {
    if (action === 'CANCEL') {
      let selectedOriginalInternetList = this.originalInternetList.find((val: any) => val.rowNumber === item.rowNumber)
      this.internetList.forEach((element: any) => {
        if (element.rowNumber === item.rowNumber) {
          element.bookmarkDisplayName = selectedOriginalInternetList.bookmarkDisplayName;
          element.bookmarkUrl = selectedOriginalInternetList.bookmarkUrl;
          element.isValidUrl = selectedOriginalInternetList.isValidUrl,
            element.isEnabledEdited = "false";
          element.onUpdateClicked = false;
        }
      });
    } else if (action === 'UPDATE') {
      if (item.bookmarkUrl.trim() !== "") {
        let isValidUrl = this.validateUrl(item.bookmarkUrl.trim());
        if (isValidUrl) {
          item.isValidUrl = true;
          this.internetList.filter((val: any) => val.rowNumber === item.rowNumber).map((element: any) => {
            if (element.bookmarkDisplayName.trim() === "" && element.bookmarkUrl.trim() !== "") {
              element.bookmarkDisplayName = this.getBookmarkDisplayNameByBookmarkUrl(element);
            }
            if (element.bookmarkDisplayName && element.bookmarkUrl) {
              element.isEnabledEdited = "false";
              element.showAddWebsiteShortcut = false;
              element.onUpdateClicked = false;
            } else {
              element.onUpdateClicked = true;
            }
          });

          if (item.bookmarkDisplayName.trim() === "" && item.bookmarkUrl.trim() !== "") {
            item.bookmarkDisplayName = this.getBookmarkDisplayNameByBookmarkUrl(item);
          }

          if (item.bookmarkDisplayName && item.bookmarkUrl) {
            this.originalInternetList.filter((val: any) => val.rowNumber === item.rowNumber).map((element: any) => {
              element.rowNumber = item.rowNumber;
              element.bookmarkDisplayName = item.bookmarkDisplayName;
              element.bookmarkUrl = item.bookmarkUrl;
              element.isEnabledEdited = "false";
              element.showAddWebsiteShortcut = false;
              element.onUpdateClicked = false;
            });
          }
        } else {
          item.isValidUrl = false;
          item.onUpdateClicked = true;
        }
      } else {
        item.isValidUrl = false;
        item.onUpdateClicked = true;
      }
    }
  }

  validateUrl(url: any) {
    return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
  }

  getBookmarkDisplayNameByBookmarkUrl(element: any) {
    let tmpName = element.bookmarkUrl.trim();
    tmpName = tmpName.toLowerCase();
    tmpName = tmpName.substr(tmpName.indexOf("://") + 3);
    if (tmpName.indexOf('www.') == 0) {
      tmpName = tmpName.substr(tmpName.indexOf("www.") + 4);
    }
    return tmpName;
  }

  ngOnDestroy(): void {
  }

}
